import {useEffect} from 'react'
import {Controller, useFormContext} from 'react-hook-form'
import ContentForm from '../../../../../../components/UI/Form/contentForm'
import {SelectWrapper} from '../../../../../../components/UI/Form/Input'
import {useCentral} from '../../../../../../hooks/useCentral'
import {useClient, useCompany, useSite} from '../../../../hooks'
import {getDocsConfigById} from '../../../../services/configDocument.service'
import {TITLE_FORM_CONFIG_DOCUMENT} from '../../../../util/Constants'

export const ConfigDocumentForm = () => {
  const {currentTabItem} = useCentral()
  const {clientList, getClientList} = useClient()
  const {companyList, getCompanyList} = useCompany()
  const {siteList, getSiteList} = useSite()

  const {
    control,
    formState: {errors},
    watch,
    setValue,
    register,
  } = useFormContext()

  const getConfigDocsById = async () => {
    try {
      const {idToEdit} = currentTabItem
      if (idToEdit) {
        const {
          data: {data},
        } = await getDocsConfigById(idToEdit as any)
        const {
          CompaniaId,
          ClienteId,
          SiteId,
          ValorBase,
          TipoDato,
          Direccion,
          ActivaExpresion,
          Expresion,
        } = data
        setValue('Id', idToEdit)
        setValue('CompaniaId', CompaniaId)
        setValue('ClienteId', ClienteId)
        setValue('SiteId', SiteId)
        setValue('ValorBase', ValorBase)
        setValue('TipoDato', TipoDato)
        setValue('Direccion', Direccion)
        setValue('ActivaExpresion', ActivaExpresion)
        try {
          const decodedContent = decodeURIComponent(escape(atob(Expresion!)))
          setValue('Expresion', decodedContent)
        } catch (error) {
          const decodedContent = decodeURIComponent(Expresion!.replace(/\+/g, ' '))
          setValue('Expresion', decodedContent)
        }
        getClientList({companiaId: CompaniaId})
        getSiteList({clienteId: ClienteId})
      }
    } catch (error) {
      console.error('Error al obtener la lista de países:', error)
    }
  }

  useEffect(() => {
    getCompanyList()
  }, [])
  useEffect(() => {
    if (currentTabItem.idToEdit) {
      getConfigDocsById()
    }
  }, [currentTabItem.idToEdit])

  let isDisabled = currentTabItem.idToEdit ? true : false

  const handleGetClientList = async (val: any) => {
    let value = val ? val.value : ''
    getClientList({companiaId: value})
  }
  const handleGetSiteList = async (val: any) => {
    let value = val ? val.value : ''
    getSiteList({clienteId: value})
  }

  // useEffect(() => {
  //   if (watch('ActivaExpresion')) {
  //     setValue('ValorBase', '')
  //     setValue('TipoDato', '')
  //     setValue('Direccion', '')
  //   } else {
  //     setValue('Expresion', '')
  //   }
  // }, [watch('ActivaExpresion')])

  const handleChangeActivaExpresion = (e: any) => {
    const valueChecked = e.target.checked
    if (valueChecked) {
      setValue('ValorBase', '')
      setValue('TipoDato', '')
      setValue('Direccion', '')
    } else {
      setValue('Expresion', '')
    }
  }

  return (
    <ContentForm isEdit={isDisabled} title={TITLE_FORM_CONFIG_DOCUMENT}>
      <div className='row'>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Compañía'
            name='CompaniaId'
            data={companyList}
            disabled={isDisabled}
            onChangeValue={handleGetClientList}
            required
          />
        </div>

        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Cliente'
            name='ClienteId'
            data={clientList}
            disabled={isDisabled}
            onChangeValue={handleGetSiteList}
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Site'
            name='SiteId'
            data={siteList}
            disabled={isDisabled}
            required
          />
        </div>
        <div className='col-sm-12 col-md-6 col-lg-3'>
          <div>
            <label className=''>Activar Expresión Regular:</label>
            <div className='sdx_form_input'>
              <div className='form-check form-switch form-check-custom form-check-solid'>
                <Controller
                  name={'ActivaExpresion'}
                  control={control}
                  // defaultValue={}
                  render={({field}) => (
                    <input
                      className='form-check-input'
                      type='checkbox'
                      id='switchActivaExpresion'
                      onChange={(e) => {
                        field.onChange(e)
                        handleChangeActivaExpresion(e)
                      }}
                    />
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {watch('ActivaExpresion') ? (
        <div className='row'>
          <div className='col-sm-12 col-md-4 col-xl-3'>
            <label className='required'>Expresión Regular</label>
            <div className='sdx_form_input'>
              <input
                type='text'
                className='form-control form-control sdx-centra-input-form'
                {...register('Expresion')}
              />
            </div>
            <p
              style={{
                marginBottom: '0',
                fontSize: '10px',
                fontWeight: '600',
                color: 'red',
                marginLeft: '5px',
              }}
            >
              {errors?.Expresion?.message?.toString()}
            </p>
          </div>
        </div>
      ) : (
        <div className='row'>
          <div className='col-sm-12 col-md-4 col-xl-3'>
            <label className='required'>Valor Base</label>
            <div className='sdx_form_input'>
              <input
                type='text'
                className='form-control form-control sdx-centra-input-form'
                {...register('ValorBase')}
              />
            </div>
            <p
              style={{
                marginBottom: '0',
                fontSize: '10px',
                fontWeight: '600',
                color: 'red',
                marginLeft: '5px',
              }}
            >
              {errors?.ValorBase?.message?.toString()}
            </p>
          </div>
          <div className='col-sm-12 col-md-4 col-xl-3'>
            <label className='required mb-4'>Tipo de Dato:</label>
            <div className='d-flex flex-column'>
              <Controller
                name={'TipoDato'}
                control={control}
                // defaultValue={}
                render={({field}) => (
                  <>
                    <label className='mb-4'>
                      <input
                        type='radio'
                        value='ALF'
                        className='form-check-input me-4'
                        checked={field.value === 'ALF'}
                        onChange={field.onChange}
                      />
                      Alfanumerico
                    </label>
                    <label className='mb-4'>
                      <input
                        type='radio'
                        value='NUM'
                        className='form-check-input me-4'
                        checked={field.value === 'NUM'}
                        onChange={field.onChange}
                      />
                      Numerico
                    </label>
                  </>
                )}
              />
            </div>
            {
              <p style={{marginBottom: 0, fontSize: '10px', fontWeight: 600, color: 'red'}}>
                {errors?.TipoDato?.message?.toString()}
              </p>
            }
          </div>
          <div className='col-sm-12 col-md-4 col-xl-3'>
            <label className='required mb-4'>Dirección:</label>
            <div className='d-flex flex-column'>
              <Controller
                name={'Direccion'}
                control={control}
                // defaultValue={}
                render={({field}) => (
                  <>
                    <label className='mb-4'>
                      <input
                        type='radio'
                        value='IZQ'
                        className='form-check-input me-4'
                        checked={field.value === 'IZQ'}
                        onChange={field.onChange}
                      />
                      Izquierda
                    </label>
                    <label className='mb-4'>
                      <input
                        type='radio'
                        value='DER'
                        className='form-check-input me-4'
                        checked={field.value === 'DER'}
                        onChange={field.onChange}
                      />
                      Derecha
                    </label>
                  </>
                )}
              />
            </div>
            {
              <p style={{marginBottom: 0, fontSize: '10px', fontWeight: 600, color: 'red'}}>
                {errors?.Direccion?.message?.toString()}
              </p>
            }
          </div>
        </div>
      )}
    </ContentForm>
  )
}
